<template>
  <div class="whole flex column">
    <div class="select-box flex align">
      <div class="select-box-title">试卷类型</div>
      <el-select @change="changeExamType" v-model="examTypeValue" multiple collapse-tags placeholder="请选择">
        <el-option v-for="item in examTypeOptions" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <!-- 班级选择器 -->
      <div class="flex align" style="margin-left: 0.3rem">
        <div class="select-box-title">班级</div>
        <el-cascader @change="classHandleChange" v-model="classValue" :options="classOptions"></el-cascader>
      </div>
    </div>
    <div class="main-content flex" style="flex: 1">
      <div class="flex column" style="border-right: 1px solid #bfbfbf">
        <!-- 考试列表标题 -->
        <div class="classTimesList-title-box flex align">
          <div class="classTimesList-block"></div>
          <div class="classTimesList-title">考试列表</div>
        </div>
        <div style="flex: 1; overflow: auto">
          <!-- 考试列表 -->
          <div @click="selectTestPaper(item)" :class="currentExamId == item.exam.id ? 'allClasses' : 'classList'"
            v-for="(item) in testPaperList" :key="item.id">
            <div class="classList-circle"></div>
            <div class="classList-name">{{ item.exam.name }}</div>
          </div>
        </div>
      </div>
      <!-- 试卷详情部分 -->
      <div v-if="showExaminationPaperDetails" class="examinationPaper-box flex column">
        <div class="flex spaceBetween">
          <div class="flex">
            <div class="examinationPaper-key">试卷名称:</div>
            <div class="examinationPaper-value">{{ currentExam.name }}</div>
          </div>
          <div class="flex align">
            <div class="examinationPaper-scheduleKey">平均分</div>
            <div class="examinationPaper-scheduleBox">
              <div class="examinationPaper-schedule"
                :style="`width: ${currentExam.averageScoreRate}; background: #fa7369`"></div>
            </div>
            <div class="examinationPaper-scheduleValue">{{ currentExam.averageScore }}分</div>
          </div>
        </div>
        <div class="flex spaceBetween">
          <div class="flex">
            <div class="examinationPaper-key">查看答案时机:</div>
            <div class="examinationPaper-value">{{ currentExam.answer_limitTxt }}</div>
          </div>
          <div class="flex align">
            <div class="examinationPaper-scheduleKey">平均用时</div>
            <div class="examinationPaper-scheduleBox">
              <div class="examinationPaper-schedule"
                :style="`width: ${currentExam.averageTakeTimeRate}; background: #1f96fa`"></div>
            </div>
            <div class="examinationPaper-scheduleValue">{{ currentExam.averageTakeTime }}</div>
          </div>
        </div>
        <div class="flex spaceBetween">
          <div class="flex">
            <div class="examinationPaper-key">考试起止时间:</div>
            <div class="examinationPaper-value">{{ currentExam.start_StopTime }}</div>
          </div>
          <div class="flex align">
            <div class="examinationPaper-scheduleKey">及格人数</div>
            <div class="examinationPaper-scheduleBox">
              <div class="examinationPaper-schedule"
                :style="`width: ${currentExam.passNumberRate}; background: #c9d656`"></div>
            </div>
            <div class="examinationPaper-scheduleValue">{{ currentExam.passNumber }}人</div>
          </div>
        </div>
        <div class="flex spaceBetween">
          <div class="flex">
            <div class="flex">
              <div class="examinationPaper-key">试卷用途:</div>
              <div class="examinationPaper-value">{{ currentExam.examUsage }}</div>
            </div>
            <div class="flex" style="margin-left: 0.5rem">
              <div class="examinationPaper-key">考试时长:</div>
              <div class="examinationPaper-value">{{ currentExam.testDuration }}</div>
            </div>
          </div>
          <div class="flex align">
            <div class="examinationPaper-scheduleKey">完成人数</div>
            <div class="examinationPaper-scheduleBox">
              <div class="examinationPaper-schedule"
                :style="`width: ${currentExam.completeNumberRate}; background: #f6c94f`"></div>
            </div>
            <div class="examinationPaper-scheduleValue">{{ currentExam.completeNumber }}人</div>
          </div>
        </div>
        <div class="marginBottom flex spaceBetween">
          <div class="flex">
            <div class="flex">
              <div class="examinationPaper-key">试卷题数:</div>
              <div class="examinationPaper-value">{{ currentExam.num_item }}</div>
            </div>
            <div class="flex" style="margin-left: 0.5rem">
              <div class="examinationPaper-key">试卷满分:</div>
              <div class="examinationPaper-value">{{ currentExam.score }}</div>
            </div>
          </div>
          <div class="flex align">
            <div class="examinationPaper-scheduleKey">未完成人数</div>
            <div class="examinationPaper-scheduleBox">
              <div class="examinationPaper-schedule"
                :style="`width: ${currentExam.uncompletedNumberRate}; background: #c490bf`"></div>
            </div>
            <div class="examinationPaper-scheduleValue">{{ currentExam.uncompletedNumber }}人</div>
          </div>
        </div>
        <!-- 学生表格部分开始 -->
        <div style="height: calc(100vh - 3.2rem)">
          <el-table :data="studentDataList" :header-cell-style="{ background: '#EEEEEE', color: '#000000' }"
            height="100%" border>
            <el-table-column align="center" label="学生姓名" prop="name"></el-table-column>
            <el-table-column align="center" label="学号" prop="account"></el-table-column>
            <el-table-column align="center" label="年级" prop="class.grade"></el-table-column>
            <el-table-column align="center" label="班级" prop="class.name"></el-table-column>
            <el-table-column align="center" label="正确率" prop="accuracy"></el-table-column>
            <el-table-column align="center" label="答题用时" prop="answerTime"></el-table-column>
            <el-table-column align="center" label="得分" prop="examScore"></el-table-column>
            <el-table-column align="center" label="答案">
              <template slot-scope="scope">
                <div @click="btnViewDetails(scope)" class="btnViewDetails pointer">查看详情</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="btnBox flex justify">
          <div v-show="showBtnReview" @click="btnReadOver" class="btnUnread flex align justify pointer"
            :style="whetherToReviewOrNot ? 'background: #349AFE;' : 'background: #999999;'">{{ whetherToReviewOrNot ?
        "已批阅" :
        "未批阅" }}</div>
          <div @click="btnViewTestPaper" class="btnViewTestPaper flex align justify pointer">查看试卷</div>
        </div>
      </div>
      <!-- 试卷详情部分 -->
      <div v-if="!showExaminationPaperDetails" class="examinationPaper-box1 flex column">
        <div style="flex: 1; overflow: auto">
          <div class="exampleList1" v-for="(item, index) in currentExamExercises" :key="index">
            <!-- 题干 -->
            <div class="flex align spaceBetween">
              <div class="flex align">
                <div class="questionNo">{{ index + 1 }}</div>
                <div class="topicType">{{ item.typesName }}</div>
              </div>
              <div class="flex align">
                <div class="flex align">
                  <div class="score-txt">分值:</div>
                  <div class="score-inputFrame flex justify">
                    <input disabled v-model="item.score" class="score-input" type="text" />
                  </div>
                </div>
                <div class="publicMarginLeft flex align">
                  <div class="score-txt">{{ item.typesName == "简答题" ? "完成人数:" : "正确人数:" }}</div>
                  <div class="score-input">{{ item.completedPersonnelNum }}/{{ studentDataList.length }}</div>
                </div>
                <img @click="viewQuestionDetails(item)" class="detailIcon pointer" src="@/assets/detailIcon.png"
                  alt="" />
              </div>
            </div>
            <div class="flex">
              <div class="exampleList-left flex column">
                <div class="flex align">
                  <div class="stem">{{ item.content }}</div>
                </div>
                <!-- 选项 -->
                <div v-if="item.typesName == '单选题' || item.typesName == '多选题' || item.typesName == '判断题'"
                  class="exampleList-option">
                  <div v-for="(item, index) in item.options" :key="index">
                    <div class="exampleList-option-txt">{{ optionOrder[index] }}.{{ item }}</div>
                  </div>
                </div>
                <!-- 答案 -->
                <div v-if="item.typesName != '简答题'" class="answer flex align">
                  <div class="answer-txt">答案:</div>
                  <div class="answer-English">{{ item.answer }}</div>
                </div>
                <!-- 解析 -->
                <div class="answer flex">
                  <div class="answer-txt">解析:</div>
                  <div class="answer-English">{{ item.comment }}</div>
                </div>
              </div>
              <echartsPie
                v-if="item.typesName == '单选题' || item.typesName == '多选题' || item.typesName == '判断题' || item.typesName == '简答题'"
                :preData="item.preData"></echartsPie>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 查看详情弹窗 -->
    <div v-if="showViewDetails" class="pop-viewDetails flex align justify">
      <div class="viewDetails-box flex column">
        <img @click="showViewDetails = false" class="btnClose pointer" src="../../../assets/classManagement/cm5.png" />
        <div class="flex align">
          <div class="select-box-title">姓名</div>
          <el-select @change="getAnswerData" v-model="studentValue" placeholder="请选择">
            <el-option v-for="item in studentOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div style="flex: 1; overflow: auto">
          <div class="exampleList" v-for="(item, index) in currentExamExercises" :key="index">
            <!-- 题干 -->
            <div class="flex align spaceBetween">
              <div class="flex align">
                <div class="questionNo">{{ index + 1 }}</div>
                <div class="topicType">{{ item.exam_item.types }}</div>
              </div>
              <div class="flex align">
                <div class="score-txt">分值:</div>
                <div class="score-inputFrame flex justify">
                  <input :disabled="item.exam_item.types == '简答题' ? false : true" v-model="item.exam_item.getScore"
                    class="score-input" type="text" />
                </div>
                <div @click="modifyTheScore(item)" v-if="item.exam_item.types == '简答题'"
                  class="modifyTheScore flex align justify pointer">修改得分</div>
              </div>
            </div>
            <div class="flex align">
              <div class="stem">{{ item.exam_item.content }}</div>
            </div>
            <!-- 选项 -->
            <div v-if="item.exam_item.types == '单选题' || item.exam_item.types == '多选题' || item.exam_item.types == '判断题'"
              class="exampleList-option">
              <div v-for="(item, index) in item.exam_item.options" :key="index">
                <div class="exampleList-option-txt">{{ optionOrder[index] }}.{{ item }}</div>
              </div>
            </div>
            <!-- 答案 -->
            <div v-if="item.exam_item.types == '单选题' || item.exam_item.types == '多选题' || item.exam_item.types == '判断题'"
              class="answer flex align">
              <div class="answer-txt">答案:</div>
              <div class="answer-English">{{ item.exam_item.answerTxt.join(",") }}</div>
            </div>
            <div v-if="item.exam_item.types == '填空题'" class="answer flex align">
              <div class="answer-txt">答案:</div>
              <div class="blankAnswer" v-for="(item, index) in item.exam_item.options" :key="index">第{{ index + 1 }}空:
                {{
        item }}</div>
            </div>
            <!-- 学生答案 -->
            <div class="answer flex align">
              <div class="answer-txt">学生答案:</div>
              <div class="answer-English">{{ item.exam_item.studentAnswer }}</div>
            </div>
            <!-- 上传结果 -->
            <div v-if="item.exam_item.types == '简答题'" class="answer flex align">
              <div class="answer-txt">上传结果:</div>
              <div @click="viewH5Detail(item, '试卷')" class="modifyTheScore flex align justify pointer">查看详情</div>
            </div>
            <!-- 解析 -->
            <div class="answer flex">
              <div class="answer-txt">解析:</div>
              <div class="answer-English">{{ item.exam_item.comment }}</div>
            </div>
          </div>
        </div>
        <div class="flex justify">
          <div @click="showViewDetails = false" class="btVerify flex align justify pointer">确认</div>
        </div>
      </div>
    </div>
    <!-- 查看详情弹窗 -->
    <div v-if="showViewQuestionDetails" class="pop-viewDetails flex align justify">
      <div class="viewQuestionDetails-box">
        <img @click="showViewQuestionDetails = false" class="btnClose pointer"
          src="../../../assets/classManagement/cm5.png" />
        <!-- 学生表格部分开始 -->
        <div class="tableBox">
          <el-table :data="studentDataList" :header-cell-style="{ background: '#EEEEEE', color: '#000000' }"
            height="100%" border>
            <el-table-column align="center" label="学生姓名" prop="name"></el-table-column>
            <el-table-column align="center" label="学号" prop="account"></el-table-column>
            <el-table-column align="center" label="年级" prop="class.grade"></el-table-column>
            <el-table-column align="center" label="班级" prop="class.name"></el-table-column>
            <el-table-column align="center" label="是否正确" width="100" prop="questionAccuracy"></el-table-column>
            <el-table-column align="center" label="得分" prop="questionScore">
              <template slot-scope="scope">
                <div v-if="questionType == '简答题'" class="flex">
                  <div class="score-inputFrame flex justify">
                    <input v-model="scope.row.questionScore" class="score-input" type="text" />
                  </div>
                  <div @click="modifyTheScore1(scope.row)" class="btnViewDetails pointer">修改得分</div>
                </div>
                <div v-if="questionType != '简答题'" class="flex justify">
                  <div>{{ scope.row.questionScore }}分</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="答案" prop="questionAnswer"></el-table-column>
            <el-table-column v-if="questionType == '简答题'" align="center" label="上传结果" prop="questionScore">
              <template slot-scope="scope">
                <div @click="viewH5Detail(scope.row, '表格')" class="btnViewDetails flex align justify pointer">查看详情</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 视频 -->
    <div class="videoDiv" v-show="showVideo">
      <img @click="btnCloseVideoDiv" class="btnVideoClose pointer" src="../../../assets/btnClose.png" />
      <video class="videoOrAudio" controls :src="videoUrl"></video>
    </div>
    <!-- 图片 -->
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="imgUrl" />
  </div>
</template>

<script>
import { classCascade, obtainTeacherTeachingClass, resourceList, courseLearningRecords, examReadOver, getExamReadOver, learningRecordsModification } from "@/api";
import echartsPie from "@/components/echarts_pie";
import { Toast } from "vant";
export default {
  data() {
    return {
      examTypeValue: ["usually", "mid", "final", "other"],
      examTypeOptions: [
        { value: "usually", label: "平时考试" },
        { value: "mid", label: "期中考试" },
        { value: "final", label: "期末考试" },
        { value: "other", label: "其他考试" },
      ],
      classOptions: [], // 班级选项
      classValue: ["2021级", 1], // 默认班级
      testPaperList: [], // 试卷列表
      currentExamId: null, // 当前选择的试卷id
      currentExamLinkId: null, // 当前选择的试卷关联id
      currentExam: {}, // 当前选择的试卷数据
      studentDataList: [], // 学生列表数据
      currentClassId: null, // 当前班级id
      currentExamExercises: [], // 当前试卷的习题列表
      studentValue: null, // 学生选择值
      studentOptions: [], // 学生选择选项
      optionOrder: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      showViewDetails: false, // 查看详情弹窗
      showExaminationPaperDetails: true, // 考试详情部分显示
      showViewQuestionDetails: false, // 查看试题详情弹窗
      showBtnReview: false, // 批阅按钮显示
      whetherToReviewOrNot: false, // 是否批阅
      questionType: "",
      showVideo: false, // 是否显示视频
      showViewer: false, // 是否显示图片
      videoUrl: "", // 视频地址
      imgUrl: [], // 图片地址
    };
  },
  components: { echartsPie, "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer") },
  created() {
    if (this.$route.params.id) {
      this.currentExamId = this.$route.params.id; // 获取试卷id
    }
    this.publicGetExam(); // 获取试卷列表
    // 获取年级班级选择器级联数据
    // classCascade().then((res) => {
    //   this.classValue[0] = res.data.datas[0].grade; // 默认年级班级选择器年级
    //   this.classValue[1] = res.data.datas[0].class[0].id; // 默认年级班级选择器班级id
    //   this.currentClassId = res.data.datas[0].class[0].id; // 当前班级id
    //   for (let i in res.data.datas) {
    //     for (let j in res.data.datas[i].class) {
    //       let publicRes = res.data.datas[i].class;
    //       publicRes[j].value = publicRes[j].id;
    //       publicRes[j].label = publicRes[j].name;
    //     }
    //     this.classOptions.push({
    //       value: res.data.datas[i].grade,
    //       label: res.data.datas[i].grade,
    //       children: res.data.datas[i].class,
    //     });
    //   }
    //   // 第一层按value从大到小排列
    //   this.classOptions.sort((a, b) => b.value.split("级")[0] - a.value.split("级")[0]);
    //   // 第二层的children按value从小到大排列
    //   this.classOptions.forEach(item => {
    //     if (item.children && Array.isArray(item.children)) {
    //       item.children.sort((a, b) => a.name.split("班")[0] - b.name.split("班")[0]);
    //     }
    //   });
    // });
    // 调用获取老师授课班级列表接口
    let params = { lesson_id: this.$store.state.courseDetails.id };
    obtainTeacherTeachingClass(params).then((res) => {
      let groupedData = res.data.datas.reduce((groups, item) => {
        (groups[item.grade] = groups[item.grade] || []).push(item);
        return groups;
      }, {});
      this.classValue[0] = res.data.datas[0].grade;
      this.classValue[1] = res.data.datas[0].id;
      this.currentClassId = res.data.datas[0].id;
      for (let key in groupedData) {
        for (let j in groupedData[key]) {
          let publicRes = groupedData[key];
          publicRes[j].value = publicRes[j].id;
          publicRes[j].label = publicRes[j].name;
        }
        this.classOptions.push({
          value: key,
          label: key,
          children: groupedData[key],
        });
      }
      // 第一层按value从大到小排列
      this.classOptions.sort((a, b) => b.value.split("级")[0] - a.value.split("级")[0]);
      // 第二层的children按value从小到大排列
      this.classOptions.forEach(item => {
        if (item.children && Array.isArray(item.children)) {
          item.children.sort((a, b) => a.name.split("班")[0] - b.name.split("班")[0]);
        }
      });
    });
  },
  methods: {
    viewH5Detail(item, type) {
      let url = "";
      if (type == "试卷") {
        url = item.exam_item.url;
      } else if (type == "表格") {
        url = item.url;
      }
      if (url != "") {
        if (this.isVideoOrImage(url) == "video") {
          this.videoUrl = url;
          this.showVideo = true;
        } else if (this.isVideoOrImage(url) == "image") {
          this.imgUrl = [url];
          this.showViewer = true;
        } else {
          this.$message("没有答题数据");
        }
      } else {
        this.$message("没有答题数据");
      }
    },
    isVideoOrImage(url) {
      if (url) {
        const ext = url.split(".").pop().toLowerCase();
        const videoExtensions = ["mp4", "webm", "mov", "avi", "mkv", "flv"];
        const imageExtensions = ["jpg", "jpeg", "png", "gif", "svg"];
        if (videoExtensions.includes(ext)) {
          return "video";
        } else if (imageExtensions.includes(ext)) {
          return "image";
        } else {
          return "unknown";
        }
      }
    },
    // 关闭视频、音频
    btnCloseVideoDiv() {
      this.showVideo = false;
      this.videoUrl = "";
    },
    // 关闭图片
    closeViewer() {
      this.showViewer = false;
    },
    // 修改试题分数
    modifyTheScore1(data) {
      // 调用学生学习记录修改接口
      let params = {
        link_resource_id: this.currentExamLinkId,
        score: data.questionScore,
        user_id: data.id,
        link_exam_item_id: data.link_exam_item_id,
      };
      learningRecordsModification(params).then((res) => {
        if (res.data.code == 0) {
          Toast("修改成功!");
        } else {
          Toast(res.data.msg);
        }
      });
    },
    // 修改试题分数
    modifyTheScore(data) {
      // 调用学生学习记录修改接口
      let params = {
        link_resource_id: this.currentExamLinkId,
        score: data.exam_item.getScore,
        user_id: this.studentValue,
        link_exam_item_id: data.id,
      };
      learningRecordsModification(params).then((res) => {
        if (res.data.code == 0) {
          Toast("修改成功!");
        } else {
          Toast(res.data.msg);
        }
      });
    },
    // 获取批阅详情
    getExamRead() {
      let user_ids = this.studentDataList.map((item) => item.id).join(",");
      // 调用获取试卷批阅详情接口
      let params = {
        link_resource_id: this.currentExamLinkId,
        user_ids: user_ids,
        link_type: "exam",
        assets_type: "",
      };
      getExamReadOver(params).then((res) => {
        // 目标时间（北京时间2025-05-31 23:59:59）
        const targetTime = new Date(this.currentExam.time_end);
        // 当前时间
        const now = new Date();
        // 比较时间戳（毫秒数） 如果超出考试截止显示批阅按钮
        const isExpired = now > targetTime;
        if (isExpired) {
          if (res.data.ext.length > 0) {
            this.showBtnReview = false;
          } else {
            this.showBtnReview = true;
            if (res.data.datas.length > 0) {
              this.whetherToReviewOrNot = false;
            } else {
              this.whetherToReviewOrNot = true;
            }
          }
        }
      });
    },
    // 批阅按钮
    btnReadOver() {
      if (this.whetherToReviewOrNot) return;
      let user_ids = this.studentDataList.map((item) => item.id).join(",");
      // 调用试卷批阅接口
      let data = {
        link_resource_id: this.currentExamLinkId,
        user_ids: user_ids,
        link_type: "exam",
        assets_type: "",
      };
      examReadOver(data).then((res) => { });
    },
    // 查看试题详情
    viewQuestionDetails(data) {
      console.log(data, this.studentDataList);
      this.questionType = data.typesName; // 题目类型
      this.showViewQuestionDetails = true; // 查看试题详情弹窗
      for (let i = 0; i < this.studentDataList.length; i++) {
        let publicRes = this.studentDataList[i];
        publicRes.questionAccuracy = "未答题"; // 初始化学生答题是否正确
        publicRes.questionScore = 0; // 初始化学生答题分数
        publicRes.questionAnswer = ""; // 初始化学生答案
        publicRes.link_exam_item_id = data.link_id; // 试题关联id
        publicRes.class = this.studentDataList[0].class; // 复制年级数据
        for (let j = 0; j < data.record.length; j++) {
          let record = data.record[j];
          if (record.user_account == publicRes.account) {
            if (record.answer == "") {
              publicRes.questionAccuracy = "未答题";
            } else {
              publicRes.questionAccuracy = record.score >= data.score ? "正确" : "错误"; // 获取学生答题是否正确
            }
            publicRes.questionScore = record.score; // 获取学生答题分数
            publicRes.url = record.url; // 学生简答题图片答案
            if (data.typesName == "单选题" || data.typesName == "多选题" || data.typesName == "判断题") {
              publicRes.questionAnswer = record.answer
                .split(",") // 分割字符串为数组 ["2", "3", "1"]
                .map((num) => String.fromCharCode(65 + parseInt(num))) // 转换为字母 ["C", "D", "B"]
                .sort() // 排序 ["B", "C", "D"]
                .join(","); // 合并为字符串 "B,C,D" // 学生答案
            } else if (data.typesName == "填空题") {
              publicRes.questionAnswer = record.answer
                .split("|")
                .map((part, index) => `第${index + 1}空:${part || "空白"}`)
                .join(" ");
            } else if (data.typesName == "简答题") {
              publicRes.questionAnswer = record.answer;
            }
          }
        }
      }
    },
    // 查看试卷
    btnViewTestPaper() {
      this.showExaminationPaperDetails = false; // 考试详情部分显示
      // 调用习题学生记录接口
      let params = {
        lesson_id: this.$store.state.courseDetails.id,
        lesson_item_id: 0,
        class_id: this.currentClassId,
        types: "exam",
        link_resource_id: this.currentExamLinkId,
      };
      courseLearningRecords(params).then((res) => {
        this.studentDataList = res.data.ext.users; // 获取学生列表
        // console.log("学生列表", this.studentDataList);
        let answerList = res.data.ext.lesson_user.filter((item) => item.link_exam_item_id != 0); // 答题记录
        let studentList = res.data.ext.users; //学生列表
        /**
         * 试卷题目数据处理
         */
        // 所有试题
        let volidPaperList = res.data.datas[0].exam.exam_items;
        // 试题类型
        let typesList = { single: "单选题", multi: "多选题", truefalse: "判断题", answer: "简答题", blank: "填空题" };
        // 试题数据
        let testPaperTable = {};
        if (volidPaperList) {
          for (let i = 0; i < volidPaperList.length; i++) {
            let { id: link_id, score, exam_item } = volidPaperList[i];
            let { content, comment, options, types: examTypes, answer } = exam_item;
            if (typesList[examTypes] == "填空题") {
              answer = options.map((item, index) => `第${index + 1}空:${item}`).join(" ");
            } else {
              answer = answer.map((item) => this.optionOrder[item]).join("、");
            }
            testPaperTable[link_id] = { link_id, content, comment, options, score, typesName: typesList[examTypes], completedPersonnelNum: 0, answer, preData: {}, record: [], getScore: 0, getAnswer: "" };
          }
        }
        // 选项正确人数
        answerList.forEach(({ user_account, link_exam_item_id, score, answer, assets_type, url }) => {
          let { score: paperScore } = testPaperTable[link_exam_item_id];
          if (score == paperScore) testPaperTable[link_exam_item_id].completedPersonnelNum++;
          testPaperTable[link_exam_item_id].record.push({ user_account, answer, score, assets_type, url });
        });
        let testPaperDataList = [];
        for (let key in testPaperTable) {
          let { typesName, record, options } = testPaperTable[key];
          // echarts数据
          let preData = {
            show: true,
            typeList: [],
          };
          // 每道题的正确率
          let accuracy = Math.floor((testPaperTable[key].completedPersonnelNum / studentList.length) * 100);
          // 每个选项的被选择数
          if (typesName == "简答题") {
            let answerNum = record.filter((item) => item.score).length; // 简答题完成数量
            preData.typeList.push({ value: answerNum, name: "已完成" }, { value: studentList.length - answerNum, name: "未完成" });
          } else {
            let list = []; // 选择题、判断题、多选题的选项列表
            let group = record
              .map((item) => item.answer.split(","))
              .reduce((acc, val) => acc.concat(val), [])
              .filter((item) => item && item != "-1")
              .reduce((acc, val) => {
                if (!acc[val]) {
                  acc[val] = [];
                }
                acc[val].push(val);
                return acc;
              }, {});
            for (let i = 0; i < options.length; i++) {
              list.push({ value: group[i]?.length || 0, name: this.optionOrder[i] });
            }
            preData.typeList = list;
          }
          // 正确率
          preData.countLength = `{totalText|${typesName != "简答题" ? "正确率" : "完成率"}}\n{totalText|${accuracy}%}`;
          testPaperTable[key].preData = preData;
          testPaperDataList.push(testPaperTable[key]);
        }
        this.currentExamExercises = testPaperDataList; // 获取试卷数据列表
      });
    },
    // 获取答题数据
    getAnswerData() {
      this.currentExamExercises.forEach((item) => {
        item.exam_item.getScore = 0; // 题目得分初始化为0
        item.exam_item.studentAnswer = ""; // 学生答案初始化为空
        item.exam_item.url = ""; // 学生简答题图片答案初始化为空
      });
      // 调用习题学生记录接口
      let params = {
        lesson_id: this.$store.state.courseDetails.id,
        lesson_item_id: 0,
        class_id: this.currentClassId,
        types: "exam",
        link_resource_id: this.currentExamLinkId,
      };
      courseLearningRecords(params).then((res) => {
        res.data.ext.lesson_user.forEach((lesson_user) => {
          this.currentExamExercises.forEach((item) => {
            if (lesson_user.link_exam_item_id == item.id && lesson_user.user_id == this.studentValue) {
              item.exam_item.getScore = lesson_user.score; // 题目得分
              item.exam_item.url = lesson_user.url; // 简答题图片答案
              if (item.exam_item.types == "单选题" || item.exam_item.types == "多选题" || item.exam_item.types == "判断题") {
                item.exam_item.studentAnswer = lesson_user.answer
                  .split(",") // 分割字符串为数组 ["2", "3", "1"]
                  .map((num) => String.fromCharCode(65 + parseInt(num))) // 转换为字母 ["C", "D", "B"]
                  .sort() // 排序 ["B", "C", "D"]
                  .join(","); // 合并为字符串 "B,C,D" // 学生答案
              } else if (item.exam_item.types == "填空题") {
                item.exam_item.studentAnswer = lesson_user.answer
                  .split("|")
                  .map((part, index) => `第${index + 1}空:${part || "空白"}`)
                  .join(" ");
              } else if (item.exam_item.types == "简答题") {
                item.exam_item.studentAnswer = lesson_user.answer;
              }
            }
          });
        });
      });
    },
    // 查看详情弹窗
    btnViewDetails(scope) {
      this.showViewDetails = true;
      this.studentValue = scope.row.id; // 学生选择值
      this.getAnswerData();
    },
    // 选择试卷
    selectTestPaper(item) {
      this.currentExamId = item.exam.id; // 当前选择的试卷id
      this.currentExamLinkId = item.id; // 当前选择的试卷关联id
      this.currentExam = item.exam; // 当前选择的试卷数据
      this.publicStudentList(); // 调用获取数据方法
      this.showExaminationPaperDetails = true; // 考试详情部分显示
    },
    // 班级选择器
    classHandleChange(value) {
      this.currentClassId = value[1]; // 当前班级id
      if (!this.showExaminationPaperDetails) {
        this.btnViewTestPaper(); // 调用查看试卷方法
      } else {
        this.publicStudentList(); // 调用获取数据方法
      }
    },
    // 选择试卷类型
    changeExamType(type) {
      this.publicGetExam(type);
    },
    // 公共获取学生列表
    publicStudentList() {
      this.currentExam.averageScore = 0; // 平均分
      this.currentExam.averageScoreRate = "0%"; // 平均分率
      this.currentExam.averageTakeTime = "00:00"; // 平均用时
      this.currentExam.averageTakeTimeRate = "100%"; // 平均用时率
      this.currentExam.passNumber = 0; // 及格人数
      this.currentExam.passNumberRate = "0%"; // 及格人数率
      this.currentExam.completeNumber = 0; // 完成人数
      this.currentExam.completeNumberRate = "0%"; // 完成人数率
      this.currentExam.uncompletedNumberRate = "100%"; // 未完成人数率
      // 调用习题学生记录接口
      if (!this.currentClassId) return
      let params = {
        lesson_id: this.$store.state.courseDetails.id,
        lesson_item_id: 0,
        class_id: this.currentClassId,
        types: "exam",
        link_resource_id: this.currentExamLinkId,
      };
      courseLearningRecords(params).then((res) => {
        this.currentExam.uncompletedNumber = res.data.ext.users.length; // 未完成人数
        // 数据转换:获取的数据
        for (let i = 0; i < res.data.datas[0]?.exam?.exam_items.length; i++) {
          let publicRes = res.data.datas[0].exam.exam_items[i].exam_item;
          publicRes.content = publicRes.content.replace(/<[^>]+>/g, ""); // 题目题干获取
          publicRes.comment = publicRes.comment.replace(/<[^>]+>/g, ""); // 题目解析获取
          publicRes.getScore = 0; // 题目得分
          publicRes.studentAnswer = ""; // 学生答案
          publicRes.answerTxt = publicRes.answer.map((num) => String.fromCharCode(65 + num));
          if (publicRes.types == "判断题") {
            publicRes.options[0] = "正确";
            publicRes.options[1] = "错误";
          }
          if (publicRes.types == "single") {
            publicRes.types = "单选题";
          } else if (publicRes.types == "multi") {
            publicRes.types = "多选题";
          } else if (publicRes.types == "truefalse") {
            publicRes.types = "判断题";
            publicRes.options[0] = "正确";
            publicRes.options[1] = "错误";
          } else if (publicRes.types == "answer") {
            publicRes.types = "简答题";
          } else if (publicRes.types == "blank") {
            publicRes.types = "填空题";
          }
        }
        this.currentExamExercises = res.data.datas[0]?.exam.exam_items; // 当前试卷的习题列表
        let averageScore = 0; // 平均分
        let averageTakeTime = 0; // 平均用时
        res.data.ext.lesson_user.forEach((lesson_user) => {
          if (lesson_user.link_exam_item_id == 0) {
            averageTakeTime += lesson_user.duration; // 平均用时
            let time = (averageTakeTime / res.data.ext.users.length).toFixed(2);
            if (time > 1) {
              this.currentExam.averageTakeTime = this.formatSeconds(time); // 平均用时
            } else {
              this.currentExam.averageTakeTime = `${time}秒`;
            }
          }
          this.currentExamExercises.forEach((item) => {
            if (lesson_user.link_exam_item_id == item.id) {
              averageScore += lesson_user.score; // 试卷平均分
              this.currentExam.averageScore = (averageScore / res.data.ext.users.length).toFixed(1); // 试卷平均分
              this.currentExam.averageScoreRate = ((this.currentExam.averageScore / this.currentExam.score) * 100).toFixed(1) + "%"; // 试卷平均分率
            }
          });
        });
        let completeNumber = 0; // 完成人数
        let uncompletedNumber = 0; // 未完成人数
        let passNumber = 0; // 及格人数
        for (let i = 0; i < res.data.ext.users.length; i++) {
          // 获取姓名选择器
          this.studentOptions = res.data.ext.users.map((user) => ({
            value: user.id,
            label: user.name,
          }));
          let publicRes = res.data.ext.users[i];
          publicRes.class = res.data.ext.users[0].class; // 复制年级数据
          publicRes.answerTime = "0秒"; // 答题用时
          publicRes.accuracy = "0题/0%"; // 完成率
          publicRes.examScore = "0分"; // 得分
          let correct_num = 0; // 正确题数
          let score = 0; // 得分
          for (let j = 0; j < res.data.ext.lesson_user.length; j++) {
            let lesson_user = res.data.ext.lesson_user[j];
            if (publicRes.id == lesson_user.user_id && lesson_user.link_exam_item_id == 0) {
              // if (lesson_user.name == '杨康怡') {
              //   console.log(lesson_user)
              // }
              console.log(lesson_user)
              publicRes.answerTime = this.formatSeconds(lesson_user.duration); // 获取答题用时
              completeNumber++; // 完成人数加1
            }
            this.currentExam.completeNumber = completeNumber; // 获取完成人数
            uncompletedNumber = res.data.ext.users.length - completeNumber;
            this.currentExam.completeNumberRate = ((completeNumber / res.data.ext.users.length) * 100).toFixed(1) + "%"; // 获取完成人数率
            this.currentExam.uncompletedNumber = uncompletedNumber; // 获取未完成人数
            this.currentExam.uncompletedNumberRate = ((uncompletedNumber / res.data.ext.users.length) * 100).toFixed(1) + "%"; // 获取未完成人数率
            this.currentExamExercises.forEach((item) => {
              if (publicRes.id == lesson_user.user_id && lesson_user.link_exam_item_id == item.id && lesson_user.link_exam_item_id != 0) {
                if (lesson_user.score >= lesson_user.score_full) {
                  correct_num++;
                  publicRes.accuracy = `${correct_num}题/${((correct_num / this.currentExamExercises.length) * 100).toFixed(1)}%`; // 获取完成率
                }
                score += lesson_user.score; // 计算得分
                publicRes.examScore = `${score}分`; // 获取得分
                publicRes.examScoreNum = score; // 获取得分
              }
            });
          }
          if (publicRes.examScoreNum >= 60) {
            passNumber++;
          }
          this.currentExam.passNumber = passNumber; // 获取及格人数
          this.currentExam.passNumberRate = ((passNumber / res.data.ext.users.length) * 100).toFixed(1) + "%"; // 获取及格人数率
        }
        this.studentDataList = res.data.ext.users; // 获取学生列表
        this.getExamRead(); // 考试批阅
      });
    },
    // 格式化时间
    formatSeconds(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}分${Math.trunc(secs)}秒`;
    },
    // 公共获取试卷
    publicGetExam(type) {
      // 调用获取试卷列表接口
      let params = {
        lesson_id: this.$store.state.courseDetails.id,
        types: "exam",
        page: 1,
        num: 1000,
        lesson_item_id: 0,
        published: true,
      };
      resourceList(params).then((res) => {
        if (res.data.code == 0) {
          if (type) {
            res.data.datas = res.data.datas.filter((item) => type.includes(item.exam.usage));
          }
          res.data.datas.forEach((element, index) => {
            let item = element.exam;
            let startTime = item.time_begin.split("T")[0];
            let endTime = item.time_end.split("T")[0];
            item.start_StopTime = startTime + "—" + endTime; // 获取考试起止时间
            // console.log(item.start_StopTime);
            if (item.usage == "usually") {
              item.examUsage = "平时考试";
            } else if (item.usage == "mid") {
              item.examUsage = "期中考试";
            } else if (item.usage == "final") {
              item.examUsage = "期末考试";
            } else if (item.usage == "other") {
              item.examUsage = "其他考试";
            }
            if (item.answer_limit == "after") {
              item.answer_limitTxt = "交卷后可查看答案";
            } else if (item.answer_limit == "no") {
              item.answer_limitTxt = "不可查看答案";
            } else if (item.answer_limit == "time") {
              const formattedDate = item.answer_time.split("T")[0];
              item.answer_limitTxt = formattedDate + "后";
            }
            if (item.time_total == 0) {
              item.testDuration = "不限时";
            } else {
              item.testDuration = item.time_total + "分钟";
            }
            if (item.id == this.currentExamId) {
              this.currentExam = item; // 当前选择的试卷数据
              this.currentExamLinkId = element.id; // 当前选择的试卷关联id
            }
            if (!this.currentExamId && index == 0) {
              this.currentExam = item; // 当前选择的试卷数据
              this.currentExamId = item.id; // 当前选择的试卷id
              this.currentExamLinkId = element.id; // 当前选择的试卷关联id
            }
          });
          this.testPaperList = res.data.datas; // 试卷列表数据
          this.publicStudentList(); // 获取学生列表
        }
      });
    },
  },
};
</script>

<style src="./index.css" scoped></style>
